import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/workspace/src/layouts/blogPost.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ul>
      <li parentName="ul">
        <p parentName="li">{`UNI, the Starswap Protocol token, is live!`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`UNI contract address: `}<a parentName="p" {...{
            "href": "https://etherscan.io/token/0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984"
          }}>{`0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`60% of the UNI genesis supply is allocated to Starswap community members, a quarter of which (15% of total supply) has already been distributed to past users`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`To start, UNI is available through four liquidity mining pools: UNI holders may vote to add more pools after an initial 30-day governance grace period`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`Community-led Growth`}</strong></p>
    <p>{`Since its inception, the Starswap Protocol (`}{`”`}{`Starswap`}{`”`}{`) has served as trustless and highly decentralized financial infrastructure.`}</p>
    <p><a parentName="p" {...{
        "href": "https://starswap.xyz/blog/Starswap-history/#ethereum-values"
      }}>{`Inspired by Ethereum`}{`’`}{`s vision`}</a>{`, we have long committed to the ideals of permissionless access, security, and immutability, all indespensable components for a future where anyone in the world can access financial services without fear of discrimination or counterparty risk.`}</p>
    <p>{`Now rivaling centralized incumbents on daily volume, Starswap`}{`’`}{`s success to date — achieved without involvement of the core development team since deployment — indicates that there is considerable demand for permissionless financial services.`}</p>
    <p>{`In less than two years, the protocol has:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Supported over `}<strong parentName="p">{`$`}{`20bn`}</strong>{` volume (`}{`$`}{`270k of which was socks!) traded by over `}<strong parentName="p">{`250,000`}</strong>{` unique addresses across `}<strong parentName="p">{`8,484`}</strong>{` unique assets`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Secured over `}<strong parentName="p">{`$`}{`1bn`}</strong>{` liquidity deposited by over `}<strong parentName="p">{`49,000`}</strong>{` unique liquidity providers (LPs), earning `}<strong parentName="p">{`$`}{`56m`}</strong>{` fees in the process`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Emerged as foundational DeFi infrastructure, with integrations across `}<strong parentName="p">{`hundreds`}</strong>{` of interfaces and applications`}</p>
      </li>
    </ul>
    <p>{`Having proven product-market fit for highly decentralized financial infrastructure with a platform that has thrived independently, `}<strong parentName="p">{`Starswap is now particularly well positioned for community-led growth, development, and self-sustainability`}</strong>{`. The introduction of UNI (ERC-20) serves this purpose, enabling shared community ownership and a vibrant, diverse, and dedicated governance system, which will actively guide the protocol towards the future.`}</p>
    <p>{`Starswap has always embraced the tenets of `}<strong parentName="p">{`neutrality and trust minimization`}</strong>{` : it is crucial that governance is constrained to where it is strictly necessary. With this in mind, the Starswap governance framework is limited to contributing to both protocol development and usage as well as development of the broader Starswap ecosystem.`}</p>
    <p>{`In doing so, `}<strong parentName="p">{`UNI officially enshrines Starswap as publicly-owned and self-sustainable infrastructure while continuing to carefully protect its indestructible and autonomous qualities`}</strong>{`.`}</p>
    <p><strong parentName="p">{`UNI Allocation`}</strong></p>
    <p>{`1 billion UNI have been minted at genesis and will become accessible over the course of 4 years. The initial four year allocation is as follows:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`60.00% to Starswap community members `}<inlineCode parentName="p">{`600,000,000 UNI`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`21.266% to team members and future employees with 4-year vesting `}<inlineCode parentName="p">{`212,660,000 UNI`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`18.044% to investors with 4-year vesting `}<inlineCode parentName="p">{`180,440,000 UNI`}</inlineCode></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`0.69% to advisors with 4-year vesting `}<inlineCode parentName="p">{`6,900,000 UNI`}</inlineCode></p>
      </li>
    </ul>
    <p>{`A `}<strong parentName="p">{`perpetual inflation rate of 2% per year will start after 4 years`}</strong>{`, ensuring continued participation and contribution to Starswap at the expense of passive UNI holders.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/3c44e284f8901d2da9e32463625c51fc/35b4f/Genesis.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "64.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAACMklEQVQ4y2WTz0sVURTHb0W1kvpb2kotWgVto40rhahNUFGmhmZhiwghoihaBC5qUQgh0aICJbNVRGopmPn81QPx6fv9Zu7MvecT9857byZdnLnMzD2f873ne67azm+ZlaVlNnJrsvp7hbXlHLmlP9RLVYgFqw1WWwhiJDSgDUQ2XfeECip1qrtlqZWqVItlasWKeyduaKS1MTYI4B4SxB4mTahkwgOJRTCAy0lWHxLGEBl2Q8uv1SLxu0X4W0nAGYBk1LlvSvZU8Ru1IaqFjK9WuLBQYfjTJvboEHQMI/c/Qxa6T2G2QmR8z7CWN/k657/t0DVX5vZUHtNxB1Qvoq7AyGRbaVRoUC2UCWtBorAlVXQTZizr24aeySoXvxfpXiwxOJ0n9sB+RPUlStdKXuhuMSS/sYWuBfsVGucilvc/Y049Djn3MqDrQ53+mR2iY3dB9SEHbyVKX897YFgKKRfKRHWdAlsKTWi9IxOzmpNPA84+a9A5Bg9vzIG6iVUDHiiqF17NJr10rhtJTfn/yG4UNPPrIWeeB5wei+l+VKB2/J5XZQ85WD8cHiT8sYk2BsK9pnhIarsfA2sZ+ajpfBKwcOIFqOuYI0NwYABRl+HSW9xZbCNq57U4DijNCuJ+emN0zI7AzOich1l1DdTVxJCecaTRPGZGWQpMDJHW2LQrxm5DhJ3KwYNpGP2CfF1PxsWIv4aSGbf21fPKPN2I6FS+SzBuTVrfXgmSvjVzmpEq/AdWQLLQPksSfwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Genesis",
            "title": "Genesis",
            "src": "/static/3c44e284f8901d2da9e32463625c51fc/c1b63/Genesis.png",
            "srcSet": ["/static/3c44e284f8901d2da9e32463625c51fc/5a46d/Genesis.png 300w", "/static/3c44e284f8901d2da9e32463625c51fc/0a47e/Genesis.png 600w", "/static/3c44e284f8901d2da9e32463625c51fc/c1b63/Genesis.png 1200w", "/static/3c44e284f8901d2da9e32463625c51fc/d61c2/Genesis.png 1800w", "/static/3c44e284f8901d2da9e32463625c51fc/97a96/Genesis.png 2400w", "/static/3c44e284f8901d2da9e32463625c51fc/35b4f/Genesis.png 4524w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/86bcb8c1b0370519e41ef91da019f9f4/afec5/Inflation.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "64.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAACK0lEQVQ4y3WTz2+MQRjHX4KIpP4dR5wcOLg4CIdKaJwECaqaReLS4NqDg5ugSUXaxFGF4iaqaUnbdLetXVXb7fvuvrvvj5l5PjLzvu92FW/yzUzmnXzm+51nHi+ob+nKYplqeU3KC8usLJX5XlmjsrjM0rdFaqtVJDEQKSTWkFiZnvFPeWkY02o0pb3VorUZEDaauHmjSbAZkAYhKIMAGJCOglhnh9ixR8QGj1QEBSiKMVOcufITmF/xSSe/QrWZgQtAYjJwLrvmyY5TiliSKMYrLc7PBZReVzH7S9B3Bxl5C12ogY7CdBQ6Ulnkgiz5BmOBqeH5QsTpT5ucmfUpvamh++6Cdx3xLsO9qa7TcD2kXq0TNzvbQBcvyWHasLKhOfE45uxEyIUvPqXpGsoBbyLeYOa04jujfpDwa72Baid/O9SRBcdMzsQcHo04Ptrh2Ljm2vsAfdACB5HdtxDrdGzWAVM/Jmy0UJ30P0CjmJhJOPRIceQZDIz84OPRsdzdkAPa6Dz5nMW2VU9luyj/ijxf0/Q/+MnkyVeYA7fBu+pg7BrKwHuHYW7DOZSot5i9DpN80VbN3nf/C/AGHEDvK8GeYcQBLyEXXxIZjbRV11n3YZMYcQ5jI+5nZF0K1NvoU08R7wZ4VxCnQTg37h63KfYWwIyRR05yWN5OLobtCptpahm5/w4eTsOH1WxNiXsyO905h5JoyXtTXH8WG+zpVj2fgxV31gOTnr7+DSy+r09gockmAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Inflation",
            "title": "Inflation",
            "src": "/static/86bcb8c1b0370519e41ef91da019f9f4/c1b63/Inflation.png",
            "srcSet": ["/static/86bcb8c1b0370519e41ef91da019f9f4/5a46d/Inflation.png 300w", "/static/86bcb8c1b0370519e41ef91da019f9f4/0a47e/Inflation.png 600w", "/static/86bcb8c1b0370519e41ef91da019f9f4/c1b63/Inflation.png 1200w", "/static/86bcb8c1b0370519e41ef91da019f9f4/d61c2/Inflation.png 1800w", "/static/86bcb8c1b0370519e41ef91da019f9f4/97a96/Inflation.png 2400w", "/static/86bcb8c1b0370519e41ef91da019f9f4/afec5/Inflation.png 4526w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><strong parentName="p">{`A Retrospective`}</strong></p>
    <p>{`Starswap owes its success to the thousands of community members that have joined its journey over the past two years. These early community members will naturally serve as responsible stewards of Starswap.`}</p>
    <p>{`15% of UNI `}<em parentName="p"><inlineCode parentName="em">{`150,000,000 UNI`}</inlineCode></em>{` can immediately be claimed by `}<strong parentName="p">{`historical liquidity providers, users, and SOCKS redeemers/holders`}</strong>{` based on a snapshot ending September 1, 2020, at 12:00 am UTC.`}</p>
    <p><em parentName="p">{`4.91664% pro-rata to all `}<strong parentName="em">{`49,192`}</strong>{` historical LPs `}<inlineCode parentName="em">{`49,166,400 UNI`}</inlineCode></em></p>
    <p><strong parentName="p">{`~49 million UNI`}</strong>{` are claimable by historical liquidity providers. The formula accounts for LP liquidity on a per-second basis since the deployment of Starswap v1, ensuring that rewards are weighted towards LPs that provided liquidity when total liquidity was low.`}</p>
    <p><em parentName="p">{`10.06136% split evenly across all `}<strong parentName="em">{`251,534`}</strong>{` historical user addresses `}<inlineCode parentName="em">{`100,613,600 UNI`}</inlineCode></em></p>
    <p>{`400 UNI are claimable by each address that has ever called the Starswap v1 or v2 contracts. This includes `}<strong parentName="p">{`~12,000`}</strong>{` addresses that have only ever submitted failed transactions — love you guys.`}</p>
    <p><em parentName="p">{`0.022% to `}<strong parentName="em">{`220`}</strong>{` SOCKS holders/redeemers `}<inlineCode parentName="em">{`220,000 UNI`}</inlineCode></em></p>
    <p>{`1000 UNI are claimable by each address that has either redeemed SOCKS tokens for physical socks or owned at least one SOCKS token at the snapshot date.`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/Starswap/retroactive-query"
      }}>{`View the formula source code here`}</a></p>
    <p><strong parentName="p">{`Community Treasury`}</strong></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/ef51d794d59869134d3d393b80cc14ad/35b4f/Release_Schedule.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "64.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAAChklEQVQ4y42T3UsUURiHT0U3XnTdTbfd9C9UZFAGZRCYgdSNdRNEFGZrrkJfUCARBAVCZbUbGYVBlBcGZRARlLuIYWUplZbhujvt7M7nOXOeOOOsGXXRwMN7ZjjvM795mSOKswU1PfmFmamv+vPHKabef8Lcf3o3wezXbxBE6EAtQm3tKyJfoZJq9hlEpWTzs2Bpx6pQKZWxi2Wqlo1d/IlbrkL4pzBKMM+RBr0g8xShIxFBxddhNQCJRsIiaqHW0qhaCiMJI9yqZGzOZ2jaITNpc+ZtiauTNsKvePi2Fzf9i0VRGKFcxfuiz+0vFVLjFq35Ii1viux9XaL5hUXPaDVOiJHGszLNS0W+EWl8V/FktsrJdxYH3hRpeV5iz6BN04DDrn6PxmzAhmuS1JBKEibCmjQesplRoHg159A9ZtH0rMz2Rx5b7kds7IdNNzQNvT47rjjsvlxm39nv9N6cNQl/C1WSkEAyWvLoHndoGA6oH4jY2evSeu4Hpw6PcaP5KcPr+5lYe4W51T04q84Qig70tj6EmV88Q1fGiZxIc2k6ovGxS8ulAucP5hnc/ICZNRdRK7tBpEAcTTgG4jiIEyDaYOt1hGe7+LaLuUZdOP1wngv7X5Jfdx2v7jSI9qS5PW7UohO1vCsmWpaO0SvSaNGObuhLhGWXqXsfeL7lLvN1Z5M3t4HoIFqeRq7oiqs2zcs6/2apMAykDj4WUCKtEYdiWSRSMTr+nP/BjOEI1F9FmJ9Xzjs6uJPHy+bwszmCzAhBNoe8nUdmckizzuQIswvrMJMjuDXyG7O/7zXh0ARC+0orT8aHonZIIiB0QyqeQ0lKLKUoqZCKDLBcDxdZO0hxDZNq+AVW92pnwBfvuAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Release Schedule",
            "title": "Release Schedule",
            "src": "/static/ef51d794d59869134d3d393b80cc14ad/c1b63/Release_Schedule.png",
            "srcSet": ["/static/ef51d794d59869134d3d393b80cc14ad/5a46d/Release_Schedule.png 300w", "/static/ef51d794d59869134d3d393b80cc14ad/0a47e/Release_Schedule.png 600w", "/static/ef51d794d59869134d3d393b80cc14ad/c1b63/Release_Schedule.png 1200w", "/static/ef51d794d59869134d3d393b80cc14ad/d61c2/Release_Schedule.png 1800w", "/static/ef51d794d59869134d3d393b80cc14ad/97a96/Release_Schedule.png 2400w", "/static/ef51d794d59869134d3d393b80cc14ad/35b4f/Release_Schedule.png 4524w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`With 15% of tokens already available to be claimed by historical users and liquidity providers, the governance treasury will retain 43% `}{`[430,000,000 UNI]`}{` of UNI supply to distribute on an ongoing basis through `}<strong parentName="p">{`contributor grants, community initiatives, liquidity mining`}</strong>{`, and other programs.`}</p>
    <p>{`UNI will vest to the governance treasury on a continuous basis according to the following schedule. Governance will have access to vested UNI starting October 18 2020 12:00am UTC.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Year`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Community Treasury`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Distribution %`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Year 1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`172,000,000 UNI`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`40%`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Year 2`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`129,000,000 UNI`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`30%`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Year 3`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`86,000,000 UNI`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20%`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Year 4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`43,000,000 UNI`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`10%`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Team, investor, and advisor UNI allocations will have tokens locked up on an identical schedule.`}</p>
    <p><strong parentName="p">{`Liquidity Mining`}</strong></p>
    <p>{`An initial liquidity mining program will go live September 18 2020 12:00am UTC. The initial program will run until November 17 2020 12:00am UTC and target the following four pools on Starswap v2:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`ETH/USDT`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`ETH/USDC`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`ETH/DAI`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`ETH/WBTC`}</p>
      </li>
    </ul>
    <p>{`5,000,000 UNI will be allocated per pool to LPs proportional to liquidity, which roughly translates to:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`83,333 UNI per pool per day`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`13.5 UNI per pool per block (14s blocktime)`}</p>
      </li>
    </ul>
    <p>{`These UNI are not subject to vesting or lock up.`}</p>
    <p>{`After 30 days, governance will reach its vesting cliff and Starswap governance will control all UNI vested to the Starswap treasury. At this point, governance can vote to allocate UNI towards grants, strategic partnerships, governance initiatives, additional liquidity mining pools, and other programs.`}</p>
    <p><strong parentName="p">{`Governance assets`}</strong></p>
    <p>{`A community-managed treasury opens up a world of infinite possibilities. We hope to see a variety of experimentation, including ecosystem grants and public goods funding, both of which can foster additional Starswap ecosystem growth. Starswap has set the standard for automated liquidity provision: it is now time to set the benchmark for responsible but radical, long-term aligned on-chain governance systems.`}</p>
    <p>{`Starswap governance will be live from day one, although control over the treasury will be delayed until October 17 2020 12:00am UTC. Control over the Starswap fee switch is subject to a 180 day time lockdelay.`}</p>
    <p>{`These grace periods provide the Starswap community enough time to familiarize itself with the governance system, bring in `}<strong parentName="p">{`a diverse and high-quality set of protocol delegates,`}</strong>{` and begin discussions and communications around potential governance proposals.`}</p>
    <p>{`UNI holders are responsible for ensuring that governance decisions are made in compliance with applicable laws and regulations. To help facilitate this, the fee switch has been initialized to a contract UNI holders can use to vote on tokens for which they will collect fees. The community is encouraged to consult knowledgeable legal and regulatory professionals before implementing any specific proposal.`}</p>
    <p>{`The Starswap team will continue to have no involvement in v2 protocol development, auditing, and other matters. Similarly, team members will not participate directly in governance for the foreseeable future, although they may delegate votes to protocol delegates without seeking to influence their voting decisions.`}</p>
    <p>{`In the meantime, UNI holders will have immediate ownership of:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Starswap governance`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`UNI community treasury`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The protocol fee switch`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Starswap.eth ENS name`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Starswap Default List (tokens.Starswap.eth)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/Starswap/status/1126506339075641344?s=20"
          }}>{`SOCKS`}</a>{` liquidity tokens`}</p>
      </li>
    </ul>
    <p>{`Initial governance parameters are as follows:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`1% of UNI total supply (delegated) to submit a governance proposal`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`4% of UNI supply required to vote `}{`’`}{`yes`}{`’`}{` to reach quorum`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`7 day voting period`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`2 day timelock delay on execution`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`Next steps`}</strong></p>
    <p>{`All historical users, liquidity providers, and SOCKS redeemers can `}<a parentName="p" {...{
        "href": "https://app.starswap.xyz/"
      }}>{`claim their UNI now`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "/3f335cd45a52ada3ee456c64a12f680a/claim.gif",
        "alt": null
      }}></img></p>
    <p>{`Liquidity providers in the preliminary set of targeted pools can `}<a parentName="p" {...{
        "href": "https://app.starswap.xyz/#/uni"
      }}>{`deposit`}</a>{` their liquidity tokens. Mining will begin on September 18th 2020 12am UTC.`}</p>
    <p><img parentName="p" {...{
        "src": "/c65fc9e83b687f4291c4907274029da3/deposit.gif",
        "alt": null
      }}></img></p>
    <p>{`UNI tokens can be delegated and used to vote through the `}<a parentName="p" {...{
        "href": "https://app.starswap.xyz/#/vote"
      }}>{`governance portal`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "/15db61d89ad5764f98485102d41b708d/vote.gif",
        "alt": null
      }}></img></p>
    <p>{`Set up an account on `}<a parentName="p" {...{
        "href": "https://gov.starswap.xyz"
      }}>{`gov.starswap.xyz`}</a>{` to start shaping and participating in protocol governance`}</p>
    <p><strong parentName="p">{`Contracts`}</strong></p>
    <p>{`UNI Token:`}</p>
    <p><a parentName="p" {...{
        "href": "https://etherscan.io/token/0x1f9840a85d5af5bf1d1762f925bdaddc4201f984"
      }}>{`https://etherscan.io/token/0x1f9840a85d5af5bf1d1762f925bdaddc4201f984`}</a></p>
    <p>{`Liquidity mining:`}</p>
    <p><a parentName="p" {...{
        "href": "https://etherscan.io/address/0x6c3e4cb2e96b01f4b866965a91ed4437839a121a"
      }}>{`Tether Liquidity Mining Pool`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://etherscan.io/address/0x7FBa4B8Dc5E7616e59622806932DBea72537A56b"
      }}>{`USDC Mining Pool`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://etherscan.io/address/0xa1484C3aa22a66C62b77E0AE78E15258bd0cB711"
      }}>{`DAI Mining Pool`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://etherscan.io/address/0xCA35e32e7926b96A9988f61d510E038108d8068e"
      }}>{`WBTC Mining Pool`}</a></p>
    <p>{`Governance:`}</p>
    <p><a parentName="p" {...{
        "href": "https://etherscan.io/address/0x5e4be8Bc9637f0EAA1A755019e06A68ce081D58F"
      }}>{`https://etherscan.io/address/0x5e4be8Bc9637f0EAA1A755019e06A68ce081D58F`}</a></p>
    <p>{`Timelock:`}</p>
    <p><a parentName="p" {...{
        "href": "https://etherscan.io/address/0x1a9c8182c09f50c8318d769245bea52c32be35bc"
      }}>{`https://etherscan.io/address/0x1a9c8182c09f50c8318d769245bea52c32be35bc`}</a></p>
    <p>{`P.S. `}<a parentName="p" {...{
        "href": "https://logo.starswap.xyz"
      }}>{`Starswap Token icon`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      